<template>
  <div class="ScrollElement" :style="{'min-height': mh, 'height': h, top: t, 'flex-direction': flexdirection, 'justify-content': justify}" :class="{'sticky': sticky, 'bg': bg}">


      <slot>
      </slot>


  </div>
</template>

<script>

//import ScrollVideo from '@assets/components/ScrollVideo.vue'
import { eventBus } from '@/utils'

export default {
  name: 'ScrollElement',
  props: {
    height: String,
    minheight: String,
    fill: Boolean,
    sticky: Boolean,
    bg: Boolean,
    top: String,
    justify: {type: String, default: 'center'},
    flexdirection: {type: String, default: 'column'}
  },
  data: function () {
    return {
    }
  },
  computed: {
    h: function () {
      if(!this.height){
        return 'auto'
      }
      else if(this.height.slice(-1) == '%'){
        return (window.innerHeight * this.height.substr(0, this.height.length - 1) / 100) + 'px';
      }
      else{
        return this.height
      }
    },
    mh: function () {
      if(!this.minheight){
        return 'auto'
      }
      else if(this.minheight.slice(-1) == '%'){
        return (window.innerHeight * this.minheight.substr(0, this.minheight.length - 1) / 100) + 'px';
      }
      else{
        return this.minheight
      }
    },
    t: function () {
      return this.top != '' ? this.top : '0px'
    },
    slots: function () {
      return this.$slots
    }
  },
  methods: {
    setCallbacks: function () {
    },
  },
  created: function () {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.ScrollElement{
  position: relative;
  overflow-x: hidden;

  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  /*background-image: linear-gradient(rgb(255,0,0,0.2), rgb(255,255,0,0.2));*/

}

.sticky {
  position: sticky;
  top: 0;
}

.bg {
  /*z-index: -1;*/
}

</style>
